import { URI } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
  };
  let path = new URL(`${URI}user/list-users/all`);
  const query = Object.keys(payload)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(payload[k])}`)
    .join('&');

  path += `?${query}`;

  const result = await fetch(path, opts);
  const jsonResult = await result.json();

  if (result.status >= 400) {
    return Promise.reject(jsonResult.message);
  }

  return jsonResult;
};
